import loadable from '@loadable/component'

export default [
  {
    path: '/code/redEnvelope/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-RedEnvelope-record" */ '~/pages/r_code/RedEnvelope/pages/record'
        )
    ),
  },
  {
    path: '/code/redEnvelope/detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-RedEnvelope-detail" */ '~/pages/r_code/RedEnvelope/pages/detail'
        )
    ),
  },
  {
    path: '/code/redEnvelope/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-RedEnvelope-rule" */ '~/pages/r_code/RedEnvelope/pages/rule'
        )
    ),
  },
]
